import React from 'react';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import { MinusIcon, PlusIcon } from '../../icons';

const NumericUpDown = ({ label, value, onChange, children, disabled }) => (
    <Grid container className="numeric-up-down">
        <Grid item xs={(children ? 5 : 7) + (disabled ? 4 : 0)}>
            <p style={{ paddingTop: '1rem' }}>{label}</p>
        </Grid>
        {disabled || (
            <Grid item container wrap="nowrap" alignItems="flex-start" xs={4}>
                <IconButton
                    onClick={() => onChange(label, +value - 1)}
                    disabled={!value || parseInt(value, 10) <= 0}
                >
                    <MinusIcon />
                </IconButton>
                <TextField
                    style={{ minWidth: 35 }}
                    className="numeric-field input"
                    type="number"
                    value={value}
                    onChange={ev => onChange(label, ev.target.value)}
                />
                <IconButton onClick={() => onChange(label, +value + 1)} disabled={value === ''}>
                    <PlusIcon />
                </IconButton>
            </Grid>
        )}
        {children ? (
            <Grid item xs={3}>
                {children}
            </Grid>
        ) : null}
    </Grid>
);

export default NumericUpDown;
